const serviceWorkerErrorPatterns = [
  /^Rejected$/,
  /firebase-messaging-sw\.js/,
  /service worker bootstrap failed/i,
];

export { serviceWorkerErrorPatterns };
